import React from 'react'
import { Button, Table, } from 'reactstrap'
import PropTypes from 'prop-types'

/**
 * Gives a table of backups the super admin
 * can unwind or restore.
 * @param {object} props 
 */
function BackupsTable ({backups, is_processing, restore, unwind}) {
  let sortedBackups = backups.sort((a, b) => b.dateUploaded - a.dateUploaded)
  return (
    <Table responsive>
      <tbody>
        <tr>
          <th>Active</th>
          <th>Date</th>
          <th>Teachers</th>
          <th>Classes</th>
          <th>Students</th>
          <th>Assessments</th>
          <th>Actions</th>
        </tr>
        {sortedBackups.map((bk, n) => 
          <tr key={`bkRow${n}`}>
            <td>{bk.active ? 'Active' : 'Inactive'}</td>
            <td>{(new Date(bk.dateUploaded)).toLocaleDateString()}</td>
            <td>{bk.createdTeachers.length}</td>
            <td>{bk.createdClasses.length}</td>
            <td>{bk.createdStudents.length}</td>
            <td>{bk.createdUserAssessments.length}</td>
            <td>
              {bk.active 
                ? <Button 
                    disabled={is_processing} 
                    onClick={() => unwind(bk)}
                  >
                    Unwind
                  </Button>
                : <Button 
                    disabled={is_processing}
                    onClick={() => restore(bk)}
                  >
                    Restore
                  </Button>
              }
            </td>
          </tr>  
        )}
      </tbody>
    </Table>
  )
}

const { array, bool, func, } = PropTypes
BackupsTable.propTypes = {
  backups: array,
  is_processing: bool.isRequired,
  restore: func.isRequired,
  unwind: func.isRequired,
}

export default BackupsTable


// WEBPACK FOOTER //
// ./src/components/Assessment/UploadCSVComponents/BackupsTable.js